<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">
          FNOL
          <small>(First Notification of Loss)</small>
        </h1>
      </template>
      <template #actions>
        <page-header-action @click.prevent="sendToQualification">
          Send to Qualification
        </page-header-action>
        <page-header-action @click.prevent="toggleNotes">
          Notes
        </page-header-action>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="card-body">
            <form-navigation-tabs
              :tabs="tabs"
              v-on:selected="setActive"
              :active="currentView"
            ></form-navigation-tabs>
            <transition name="component-fade" mode="out-in">
              <incident-source
                :incident="incident"
                v-on:created="activateTabs"
                v-on:exists="activateTabs"
                v-if="currentView == 'source'"
                v-on:unsaved-data="saveStatus"
              ></incident-source>
              <client-details
                :incident="incident"
                v-if="currentView == 'client_details'"
                v-on:unsaved-data="saveStatus"
              ></client-details>
              <client-vehicle
                :incident="incident"
                v-if="currentView == 'client_vehicle'"
                v-on:unsaved-data="saveStatus"
              ></client-vehicle>
              <vehicle-location
                :incident="incident"
                v-if="currentView == 'vehicle_location'"
                v-on:unsaved-data="saveStatus"
              ></vehicle-location>
              <client-insurance
                :incident="incident"
                v-if="currentView == 'client_insurance'"
                v-on:unsaved-data="saveStatus"
              ></client-insurance>
              <accident-details
                :incident="incident"
                v-if="currentView == 'accident_details'"
                v-on:unsaved-data="saveStatus"
              ></accident-details>
              <parties
                :incident="incident"
                v-if="currentView == 'parties'"
                v-on:unsaved-data="saveStatus"
              ></parties>
            </transition>
          </div>
          <div class="card-footer text-right" v-if="currentView == 'details'">
            <button
              class="btn btn-primary btn-raised"
              name="save"
              v-on:click.prevent="submit"
            >
              <i class="icon icon-save"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <notes-window
      :show="notes"
      :incident="incident"
      v-on:toggle-note="toggleNotes"
    ></notes-window>
  </div>
</template>

<script>
import Notes from './../Shared/Notes.vue';

import Source from './Sections/Source.vue';
import ClientDetails from './Sections/ClientDetails.vue';
import ClientVehicle from './Sections/ClientVehicle.vue';
import VehicleLocation from './Sections/VehicleLocation.vue';
import ClientInsurance from './Sections/ClientInsurance.vue';
import AccidentDetails from './Sections/AccidentDetails.vue';
import Parties from './Sections/Parties.vue';
import PageHeader from './../Shared/PageHeader.vue';
import PageHeaderAction from './../Shared/PageHeaderAction.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  components: {
    PageHeader,
    PageHeaderAction,
    'notes-window': Notes,
    'incident-source': Source,
    'client-details': ClientDetails,
    'client-vehicle': ClientVehicle,
    'vehicle-location': VehicleLocation,
    'client-insurance': ClientInsurance,
    'accident-details': AccidentDetails,
    parties: Parties
  },

  data() {
    return {
      notes: false,
      currentView: this.$route.hash
        ? this.$route.hash.replace('#', '')
        : 'source',
      unsaved_data: false,
      tabs: [
        {
          name: 'source',
          label: 'Source',
          disabled: false
        },
        {
          name: 'client_details',
          label: 'Client Details',
          disabled: false
        },
        {
          name: 'client_vehicle',
          label: 'Client Vehicle',
          disabled: false
        },
        {
          name: 'vehicle_location',
          label: 'Vehicle Location',
          disabled: false
        },
        {
          name: 'client_insurance',
          label: 'Client Insurance',
          disabled: false
        },
        {
          name: 'accident_details',
          label: 'Accident Details',
          disabled: false
        },
        {
          name: 'parties',
          label: 'Parties',
          disabled: false
        }
      ]
    };
  },

  methods: {
    sendToQualification() {
      window
        .swal({
          title: 'Please Confirm',
          text: 'Are you sure you want to send this incident to qualification?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        })
        .then(confirm => {
          if (confirm) {
            window.Ajax.post(`/first-notice-of-loss/${this.incident}/complete`)
              .then(response => {
                this.route(`/qualification/${this.incident}`);
              })
              .catch(error => {
                window.toastify.error(
                  'Error',
                  'Sorry, there was an issue sending the incident to qualification.'
                );
              });
          }
        })
        .catch(dismiss => {});
    },

    toggleNotes() {
      this.notes = !this.notes;
    },

    setActive(tab) {
      // check if unsaved data on the current form
      if (this.unsaved_data && this.currentView !== tab) {
        this.saveWarning(tab); // show alert if there is
      } else {
        this.currentView = tab;
      }
    },

    activateTabs() {
      this.tabs.forEach(tab => {
        tab.disabled = false;
      });
    },

    saveStatus(event) {
      this.unsaved_data = event;
    },

    saveWarning(tab) {
      window
        .swal({
          title: 'Are you sure?',
          text:
            'You will lose all details entered in this section if you continue!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Continue without saving',
          cancelButtonText: 'Cancel and stay in this section'
        })
        .then(
          () => {
            // Go to selected tab discarding changes
            this.currentView = tab;
            this.unsaved_data = false;
          },
          dismiss => {}
        );
    }
  }
};
</script>
